import { useContext } from "react";
import { AuthContext } from "../Contexts/authContext";

function useAuth() {
  const auth = useContext(AuthContext);
  return auth;
}

export default useAuth;
